<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          Primary texts ({{ keys.length }}/{{ maxVariables }}):
          <br />
          <span class="disclaimer">Recommended: 50 characters.</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12" *ngFor="let primaryTextKey of keys">
          <app-block-text
            [type]="'content'"
            [isPlainText]="true"
            (handleOnChange)="onChange($event, primaryTextKey)"
            (handleVariableRemoval)="variableRemoval($event)"
            [blockData]="block.variables?.[primaryTextKey] ?? ''"
            [maxLength]="150"
            [placeholder]="primaryTextPlaceholder"
            [variable]="primaryTextKey"
            [blockId]="block.blockId"
            [isSubBlockDeletable]="true"
          ></app-block-text>
        </div>
        <div class="col-12 mt-2">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            (click)="add()"
            [disabled]="!canAdd"
          >
            <i class="bi bi-plus-lg"></i> Add Primary Text
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
